const template = require('./content.html');

export default {
    template,
    transclude: true
};
